import { render, staticRenderFns } from "./PostPagination.vue?vue&type=template&id=9c388332&scoped=true"
import script from "./PostPagination.vue?vue&type=script&lang=js"
export * from "./PostPagination.vue?vue&type=script&lang=js"
import style0 from "./PostPagination.vue?vue&type=style&index=0&id=9c388332&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c388332",
  null
  
)

export default component.exports